import PropTypes from 'prop-types';
import React, { useContext, useState, useMemo } from 'react';

import * as AppPropTypes from '../lib/PropTypes';

const SiteContext = React.createContext(null);

export const usePage = () => {
    const { page } = useContext(SiteContext) || {};
    return page;
};

export const useDomain = () => {
    const { domain } = useContext(SiteContext) || {};
    return domain;
};

export const useViewerGoogleAnalyticsId = () => {
    const { viewerGoogleAnalyticsId = null } = useContext(SiteContext) || {};
    return viewerGoogleAnalyticsId;
};

const propTypes = {
    children: PropTypes.node.isRequired,
    page: AppPropTypes.page,
    domain: PropTypes.string,
    viewerGoogleAnalyticsId: PropTypes.string,
};

const defaultProps = {
    page: null,
    domain: null,
    viewerGoogleAnalyticsId: null,
};

export const SiteProvider = ({ page: initialPage, domain, children, viewerGoogleAnalyticsId }) => {
    const [pages, setPages] = useState(
        initialPage !== null ? { [initialPage.url]: initialPage } : {},
    );
    const value = useMemo(
        () => ({ page: initialPage, pages, setPages, domain, viewerGoogleAnalyticsId }),
        [initialPage, pages, setPages, domain, viewerGoogleAnalyticsId],
    );
    return <SiteContext.Provider value={value}>{children}</SiteContext.Provider>;
};

SiteProvider.propTypes = propTypes;
SiteProvider.defaultProps = defaultProps;

export default SiteContext;
